import { useEffect } from 'react';

export default function HomePageHead() {
  useEffect(() => {
    document.title = '糖豆视频 | 高清免费在线观看平台 - 电影电视剧综艺全集不缓冲';

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', '糖豆视频汇聚高清免费视频平台入口，提供电影电视剧综艺全集在线观看，流畅不卡顿无需下载。糖豆视频致力于为用户打造一站式的优质影视内容发现与导航服务。');
    setMeta('keywords', '糖豆视频,高清免费视频,在线观看平台,免费影视,电影电视剧,视频大全,综艺节目,不缓冲,影视导航');
    setMeta('og:title', '糖豆视频 | 高清免费在线观看平台 - 电影电视剧综艺全集不缓冲', true);
    setMeta('og:description', '糖豆视频汇聚高清免费视频平台入口，提供电影电视剧综艺全集在线观看，流畅不卡顿无需下载。', true);
    setMeta('og:type', 'website', true);

    const addJSONLD = (id: string, data: object) => {
      let el = document.getElementById(id);
      if (el) el.remove();
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      el.textContent = JSON.stringify(data);
      document.head.appendChild(el);
    };

    addJSONLD('ld-website', {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '糖豆视频',
      url: 'https://tangdou.com/',
      description: '糖豆视频汇聚高清免费视频平台入口，提供电影电视剧综艺全集在线观看，流畅不卡顿无需下载。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://tangdou.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    });

    addJSONLD('ld-org', {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '糖豆视频',
      url: 'https://tangdou.com/',
      description: '糖豆视频成立于2020年，是一家专注于高清免费影视内容导航的在线平台。',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '400-888-9999',
        contactType: 'customer service',
        email: 'contact@tangdou.com',
      },
      address: {
        '@type': 'PostalAddress',
        addressLocality: '北京',
        addressRegion: '朝阳区',
        streetAddress: '光华路88号糖豆大厦',
      },
    });
  }, []);

  return null;
}